module.exports = __webpack_public_path__ + "static/media/xlsx.51fb00b9.png";